import React, { useState } from 'react';
import {
  PageHeader, InlineFilters, DataTable, Tag, TextInput, exportRows,
} from '@NP-Webber/crm-kit/dist/next/index.js';
import api from '../../services/api.js';
import { formatHebrewDateTime } from '../../utils/hebrewDate';
import { useServerTable, sortParams } from '../../next/ui';

/** יומן ביקורת — new design. Same endpoint and filters as AuditLogList (/audit-logs, server paging). */
const ACTIONS = { create: { label: 'יצירה', tone: 'success', icon: 'plus' }, update: { label: 'עדכון', tone: 'info', icon: 'edit' }, delete: { label: 'מחיקה', tone: 'danger', icon: 'trash' } };
const SOURCES = { web: { label: 'ווב', icon: 'grid' }, ivr: { label: 'IVR', icon: 'phone' }, system: { label: 'מערכת', icon: 'gear' } };

export default function AuditLogListNext() {
  const [entityType, setEntityType] = useState('');
  const [source, setSource] = useState('');
  const [performedBy, setPerformedBy] = useState('');
  const [byInput, setByInput] = useState('');
  const [entityTypes, setEntityTypes] = useState([]);

  const params = (q) => ({ ...sortParams(q, 'timestamp'), entityType, source, performedBy });
  const t = useServerTable(async (q) => {
    const { data: res } = await api.get('/audit-logs', { params: { page: q.page, pageSize: q.pageSize, ...params(q) } });
    setEntityTypes((prev) => [...new Set([...prev, ...(res.data || []).map((r) => r.entityType).filter(Boolean)])].sort());
    return { rows: res.data || [], total: res.total };
  }, [entityType, source, performedBy]);
  const change = (setter) => (v) => { setter(v); t.resetPage(); };

  return (
    <>
      <PageHeader title="יומן ביקורת" sub={t.total ? `${Number(t.total).toLocaleString('he-IL')} פעולות — מי שינה מה ומתי` : 'מי שינה מה ומתי'} />
      <InlineFilters
        items={[
          { key: 'source', label: 'מקור', type: 'chips', value: source, onChange: change(setSource), options: [{ value: '', label: 'הכל' }, ...Object.entries(SOURCES).map(([value, s]) => ({ value, label: s.label }))] },
          { key: 'entity', label: 'ישות', type: 'select', value: entityType, onChange: change(setEntityType), placeholder: 'כל הישויות', options: entityTypes.map((x) => ({ value: x, label: x })) },
        ]}
        end={(
          <TextInput
            style={{ width: 200 }}
            placeholder="מבצע — Enter לסינון"
            value={byInput}
            onChange={(e) => setByInput(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') change(setPerformedBy)(byInput.trim()); }}
            onBlur={() => { if (byInput.trim() !== performedBy) change(setPerformedBy)(byInput.trim()); }}
          />
        )}
      />
      <DataTable
        mode="server"
        {...t.tableProps}
        rowKey="_id"
        selectable={false}
        searchable={false}
        storageKey="bchinot-audit"
        exportFilename="יומן_ביקורת"
        onExport={async ({ format, columns }) => {
          const { data: res } = await api.get('/audit-logs', { params: { all: 1, ...params(t.query) } });
          await exportRows(res.data || [], columns, { format, filename: 'יומן_ביקורת' });
        }}
        emptyTitle="אין רשומות יומן"
        columns={[
          { key: 'timestamp', label: 'תאריך', type: 'date', render: (r) => formatHebrewDateTime(r.timestamp) || '—' },
          { key: 'entityType', label: 'ישות', render: (r) => <b>{r.entityType}</b> },
          { key: 'entityId', label: 'מזהה ישות', ltr: true, copy: true, render: (r) => <span className="nx-code" title={r.entityId}>{r.entityId ? `${String(r.entityId).substring(0, 10)}…` : '—'}</span> },
          { key: 'action', label: 'פעולה', getValue: (r) => ACTIONS[r.action]?.label || r.action, render: (r) => (ACTIONS[r.action] ? <Tag tone={ACTIONS[r.action].tone} icon={ACTIONS[r.action].icon}>{ACTIONS[r.action].label}</Tag> : r.action) },
          { key: 'performedBy', label: 'מבצע' },
          { key: 'source', label: 'מקור', getValue: (r) => SOURCES[r.source]?.label || r.source, render: (r) => (SOURCES[r.source] ? <Tag icon={SOURCES[r.source].icon}>{SOURCES[r.source].label}</Tag> : r.source) },
        ]}
      />
    </>
  );
}
